/**
 * Le numéro de portable que le livreur appelle sur le chantier : la règle
 * même que le serveur applique (des chiffres, au moins neuf, des espaces, un
 * « + » en tête).
 */
const PORTABLE = /^\s*\+?\s*(?:\d\s*){9,20}$/;

/**
 * @param {string} [numero] numéro saisi
 * @returns {boolean} vrai si le serveur l'acceptera
 */
export function portableValable(numero) {
  return typeof numero === 'string' && numero.length <= 40 && PORTABLE.test(numero);
}

/**
 * @param {string} [numero] numéro tel qu'il s'affiche
 * @returns {string|undefined} le lien qui ouvre l'appel, rien sans numéro
 */
export function lienAppel(numero) {
  const net = String(numero || '').replace(/[^\d+]/g, '');
  return net ? 'tel:' + net : undefined;
}
